import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Loading from "@atoms/Loading";

import { URLS } from "@const/urls";

export default function Refresh() {
  const navigate = useNavigate();

  const deleteAllStorage = () => {
    // 쿠키 제거
    document.cookie.split(";").forEach((cookie) => {
      document.cookie = cookie.replace(/^ +/, "").replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
    });

    // 세선 제거
    sessionStorage.clear();

    // 로컬 제거
    localStorage.clear();

    // 첫 진입
    localStorage.setItem("renewal", "true");
  };

  useEffect(() => {
    deleteAllStorage();
    navigate(URLS.HOME);
    navigate(0);
  }, []);

  return <Loading type="page" />;
}
